import React from 'react';

import Funcion from './Funcion';
import AgregarFuncion from './AgregarFuncion';

const TableRow = (props) => {

    let codigoPerfil, textoTooltip;
    let funciones = (props.perfil.first && !props.activate) ?
        <label>Por favor seleccione un Producto, Categoría y Programa para editar los permisos</label> : "";

    if (props.perfil.functions.length > 0) {
        funciones = props.perfil.functions.map(function (func) {
            return (
                <Funcion funcion={func}
                    perfilId={props.perfil.Id}
                    deleteFuncion={props.deleteFuncion} />
            );
        });
    }

    let buttonWithoutFunctions =
        <li className="inlineListItem">
            <div className="btn-group">
                <button className="btn-tag btn-tag-closable btn-tag-add" type="button">
                    <span className="ti-plus span-closable color-white" title="No hay más funciones para agregar"></span>
                </button>
            </div>
        </li>;

    let funcionalidades = ((props.funciones_tabla.length - 1 === props.perfil.functions.length) || (props.funciones_tabla.length === 0))
        ? buttonWithoutFunctions :
        <AgregarFuncion perfilId={props.perfil.Id}
            funciones_tabla={props.funciones_tabla}
            funciones={props.perfil.functions}
            addFuncion={props.addFuncion} />;

    let lengthHasta = props.perfil.Codigo == props.perfil.Codigo.toUpperCase ? 16 : 20;
    let cortarCaracterHasta = props.perfil.Codigo == props.perfil.Codigo.toUpperCase ? 13 : 17;

    if (props.perfil.Codigo.length >= lengthHasta) {
        textoTooltip = props.perfil.Codigo;
        codigoPerfil = props.perfil.Codigo.substr(0, cortarCaracterHasta) + "...";
    } else {
        codigoPerfil = props.perfil.Codigo;
    }


    return (
        <tr>
            <td>
                <label style={{ whiteSpace: 'normal' }}  key={textoTooltip} data-toggle="tooltip" title={textoTooltip} className="lbl-perfil" data-placement="top">{codigoPerfil}</label>
            </td>
            <td colSpan="4" className="left-separator">
                {funciones}
                {funcionalidades}
            </td>
        </tr>
    );
}

export default TableRow;